import React, { Fragment, useContext, useState } from 'react'
import { AiFillHome } from "@react-icons/all-files/ai/AiFillHome";
import { BsCalendar } from "@react-icons/all-files/bs/BsCalendar";
//Calendario_admiin

import { MdFamilyRestroom, MdTipsAndUpdates, MdKeyboardArrowRight, MdOutlineKeyboardArrowRight, MdFullscreen } from 'react-icons/md';
import { IoDocumentTextOutline, IoIosDocument, IoMdArrowDropdown, IoMdBook } from 'react-icons/io';
import { FaPlus } from 'react-icons/fa';
import { AiOutlineQuestionCircle, AiFillFolder, AiFillFile, AiOutlineCloseCircle, AiOutlineSearch } from 'react-icons/ai'
import { SiHandshake } from 'react-icons/si'
import { BiCalendar, BiEdit } from 'react-icons/bi'
import Renderif from '../../components/renderif';
import SideMenu, { AdminSideMenu } from '../../components/sidemenu';

import CheckBox from '../../components/checkbox';
import DropDown, { DropDownOption } from '../../components/dropdown';
import BVCalendar from '../../components/calendar';
import { gray30, primary } from '../../utils/colors';
import Slider from '../../components/slider';
// import AgendarCitaFamiliar from './agendar_familia_client';
import { Await, useNavigate } from 'react-router-dom';
import { Service } from '../../services/api';
import { AlertContext } from '../../context/alert_context';
import { GoDotFill, GoStarFill } from "react-icons/go";
import { GoStar } from "react-icons/go";
import { BsArrowRightSquareFill } from "react-icons/bs";
import { FiShoppingBag } from 'react-icons/fi';
import { IoStatsChart } from 'react-icons/io5';
import { HiOutlineVideoCamera } from 'react-icons/hi2';
import { AuthContext } from '../../context/auth_context';
import AgendarAdmin from './agendar_admin';
import Loader from '../../components/loader';
import EditarCitaClient from '../client/editar_cita_client';





Date.prototype.addDays = function (days) {
    var date = new Date(this.valueOf());
    date.setDate(date.getDate() + days);
    return date;
}
export default function CalendarioAdmin() {

    const { notify } = useContext(AlertContext)
    const { user } = useContext(AuthContext)
    const navigate = useNavigate();
    const [state, setState] = useState({
        loading: false,
        init_date: new Date(),
        citas: [],
        show_editar_cita: false,
        cita_editing: null,
        show_agendar_cita: false,
        specialists_pisco_s: [],
        specialists_couch_s: [],
        specialists_toSearch: [],
        selected_specialist_search: null,
    })

    useState(() => {
        const init = async () => {
            setState({ ...state, loading: true })
            let _citas = await Service('GET', 'Appointment');
            let today = new Date();
            let next_citas = _citas.data.data.filter((cita) => new Date(cita[0].dateOfEvent) > today).sort((citaA, citaB) => Number(new Date(citaA.dateOfEvent)) - Number(new Date(citaB.dateOfEvent)))
            next_citas.sort((a, b) => new Date(a[0].dateOfEvent).getTime() - new Date(b[0].dateOfEvent).getTime() );
            const couch_s = await Service('GET', 'Appointment/specialist/2')
            // console.log(couch_s)
            state.specialists_couch_s= couch_s.data;
            // console.log(state.specialists_couch_s)

            let _citas_by_appoiment = await Service('GET', 'Appointment/aa534137-f287-48b2-866a-f2816973f335');
            console.log(_citas_by_appoiment)
            setState({
                ...state,
                citas: next_citas,
                loading: false
            })
            console.log(_citas)
        };
        init();
        return () => { }
    }, [])

    const getCitas = async () => {
        setState({ ...state, loading: true })
        let _citas = await Service('GET', 'Appointment');
        let today = new Date();
        let next_citas = _citas.data.data.filter((cita) => new Date(cita.dateOfEvent) > today).sort((citaA, citaB) => Number(new Date(citaA.dateOfEvent)) - Number(new Date(citaB.dateOfEvent)))

        setState({
            ...state,
            citas: next_citas,
            loading: false
        })
    }



    const addDays = (days, date) => {

        date.setDate(date.getDate() + days);
        return date;
    }
    const subDays = (days, date) => {
        date.setDate(date.getDate() - days);
        return date;
    }


    // let date = new Date();
    // console.log(date.addDays(5));


    const y = [0, 30, 60, 90, 120, 150]
    const time_mock = [
        "2024-03-00T01:00:00",
        "2024-03-01T02:00:00",
        "2024-03-02T03:00:00",
        "2024-03-03T04:00:00",
        "2024-03-04T05:00:00",
        "2024-03-05T06:00:00",
        "2024-03-06T07:00:00",
        "2024-03-07T08:00:00",
        "2024-03-08T09:00:00",
        "2024-03-09T10:00:00",
        "2024-03-10T11:00:00",
        "2024-03-11T12:00:00",
        "2024-03-12T13:00:00",
        "2024-03-13T14:00:00",
        "2024-03-14T15:00:00",
        "2024-03-15T16:00:00",
        "2024-03-16T17:00:00",
        "2024-03-17T18:00:00",
        "2024-03-18T19:00:00",
        "2024-03-19T20:00:00",
        "2024-03-20T21:00:00",
        "2024-03-21T22:00:00",
        "2024-03-22T23:00:00",
        "2024-03-23T00:00:00",
    ]
    const time = [
        '0:00 AM',
        '1:00 AM',
        '2:00 AM',
        '3:00 AM',
        '4:00 AM',
        '5:00 AM',
        '6:00 AM',
        '7:00 AM',
        '8:00 AM',
        '9:00 AM',
        '10:00 AM',
        '11:00 AM',
        '12:00 PM',
        '13:00 PM',
        '14:00 PM',
        '15:00 PM',
        '16:00 PM',
        '17:00 PM',
        '18:00 PM',
        '19:00 PM',
        '20:00 PM',
        '21:00 PM',
        '22:00 PM',
        '23:00 PM',
    ]
    const times = [
        '00',
        '01',
        '02',
        '03',
        '04',
        '05',
        '06',
        '07',
        '08',
        '09',
        '10',
        '11',
        '12',
        '13',
        '14',
        '15',
        '16',
        '17',
        '18',
        '19',
        '20',
        '21',
        '22',
        '23',
    ]

    var weekday = new Array(7);
    weekday[0] = "Domingo";
    weekday[1] = "Lunes";
    weekday[2] = "Martes";
    weekday[3] = "Miercoles";
    weekday[4] = "Jueves";
    weekday[5] = "Viernes";
    weekday[6] = "Sabado";

    var months = new Array(7);
    months[0] = "Enero";
    months[1] = "Febrero";
    months[2] = "Marzo";
    months[3] = "Abril";
    months[4] = "Mayo";
    months[5] = "Junio";
    months[6] = "Julio";
    months[7] = "Agosto";
    months[8] = "Septiembre";
    months[9] = "Octubre";
    months[10] = "Noviembre";
    months[11] = "Diciembre";

    const getRestDays = (day, date, tile_index,) => {


        // if(tile_index === 6){
        //     console.log(tile_index)
        //     console.log(day)
        // }



        // if(tile_index === day){

        //     return date;
        // }


        let a = new Date(state.init_date);


        return subDays(((day) - tile_index), a).getDate();






    }
    const getTileDate = (day, date, tile_index,) => {


        // if(tile_index === 6){
        //     console.log(tile_index)
        //     console.log(day)
        // }



        // if(tile_index === day){

        //     return date;
        // }


        let a = new Date(state.init_date);


        return subDays(((day) - tile_index), a)






    }
    const TileAppointmentCheck = (tile_date) => {

        // let a = Date.parse(new Date())
        // let b = Date.parse(new Date())
        let reserved = false
        let cita;
        state.citas.map((item, i) => {
            let cita_group = item;
            cita_group.map((item_cita_group, i) => {
                // console.log(item_cita_group)
                if (Date.parse(tile_date) === Date.parse(new Date(item_cita_group.dateOfEvent))) {
                    reserved = true
                    cita = item_cita_group;
                }
            })


        })


        return {
            reserved,
            cita,
        }


    }
    return (
        <>
            <Renderif isTrue={state.loading}>
                <Loader></Loader>
            </Renderif>
            <Renderif isTrue={state.show_agendar_cita}>



                <AgendarAdmin onSchedule={(cita) => {
                    state.show_agendar_cita = false
                    getCitas();
                    // setState({...state, show_agendar_cita:false})
                }} onCancel={() => {
                    setState({ ...state, show_agendar_cita: false })
                }}></AgendarAdmin>


            </Renderif>
            <Renderif isTrue={state.show_editar_cita}>
                <EditarCitaClient
                    cita={state.cita_editing}
                    onDelete={(cita) => {
                        state.next_citas = state.next_citas.filter((item) => item.id !== cita.id)
                        setState({ ...state, show_agendar_cita: false })
                    }}
                    onSchedule={(cita) => {

                        getCitas()
                    }}
                    onCancel={() => {
                        setState({ ...state, show_editar_cita: false })
                    }}></EditarCitaClient>
            </Renderif>

            <div className='container-fluid h-100 d-flex'>


                {/* <SideMenu></SideMenu> */}
                <AdminSideMenu></AdminSideMenu>

                <div className='col hide-scroll'>

                    <div className='container-fluid bg-light'>
                        <div className='container'>
                            <div className='row'>
                                <div className='d-flex  p-3'>
                                    <div className='d-flex align-items-center'>
                                        <div className='avatar avatar--mid'></div>
                                        <div className='col ps-3'>
                                            <div className='f-18 bold '>¡Hola! {user.firstName} {user.lastName}.</div>
                                            <div className='text-gray f-14 line-0'>Medicina General</div>
                                        </div>
                                    </div>
                                    <div className='col'></div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div className='container'>


                        <div className='d-flex'>

                            <div className='bg-gray b-right vh-85 overflow-auto hide-scroll pb-5 sticky-top-header'>

                                <div className='f-16 bold text-blue text-center mt-4'>Agenda General</div>

                                <Renderif isTrue={state.citas.length === 0}>

                                    <div className='d-flex ps-2 pe-4 py-2 opacity-0'>
                                        <div>
                                            <div className='bv-icon bv-icon--mid'>
                                                <GoDotFill size={26} color='#0972CE'></GoDotFill>
                                            </div>
                                        </div>
                                        <div>
                                            <div className='f-12 bold ps-1 line-0'></div>
                                            <div className='f-10 text-gray ps-1 line'></div>


                                            <div className='d-flex align-items-center'>
                                                <div className='bv-icon bv-icon--mid'>
                                                    <HiOutlineVideoCamera size={20} color="#0972CE"></HiOutlineVideoCamera>
                                                </div>
                                                <div className='text-blue f-12'>Videollamada</div>
                                            </div>

                                        </div>
                                    </div>

                                </Renderif>

                                {
                                    state.citas.map((item, i) => {
                                        let takeItem = item;
                                        console.log(state.citas)
                                        return (
                                            takeItem.map((itemtaked, y) => {
                                                // console.log(itemtaked.dateOfEvent)
                                                return (
                                                    <div className='d-flex ps-2 pe-4 py-2'>
                                                        <div>
                                                            <div className='bv-icon bv-icon--mid'>
                                                                <GoDotFill size={26} color='#0972CE'></GoDotFill>
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <div className='f-12 bold ps-1 line-0'>{new Date(itemtaked.dateOfEvent).getHours()}:{itemtaked.dateOfEvent.substring(14, itemtaked.dateOfEvent.length - 3)} - {new Date(itemtaked.dateOfEvent).getHours() + 1}:{itemtaked.dateOfEvent.substring(14, itemtaked.dateOfEvent.length - 3)}</div>
                                                            <div className='f-10 text-gray ps-1 line'>{weekday[new Date(itemtaked.dateOfEvent).getDay()]} {new Date(itemtaked.dateOfEvent).getDate()} {months[new Date(itemtaked.dateOfEvent).getMonth()]} {new Date(itemtaked.dateOfEvent).getFullYear()}</div>
                                                            <div className='text-gray f-12 line-0 ps-1'>Cita con {itemtaked?.patient?.firstName} {itemtaked?.patient?.lastName}</div>

                                                            <div className='d-flex align-items-center'>
                                                                <div className='bv-icon bv-icon--mid'>
                                                                    <HiOutlineVideoCamera size={20} color="#0972CE"></HiOutlineVideoCamera>
                                                                </div>
                                                                <div className='text-blue f-12'>Videollamada</div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                )
                                            })
                                        )
                                    })
                                }



                                {/* <div className='text-gray text-center f-16 line-0 ps-1 mt-3'><span className='bolder'>Hoy:</span> 26/11/2024 </div>
                            
                            <div className='d-flex ps-2 pe-4 py-2'>
                                <div>
                                    <div className='bv-icon bv-icon--mid'>
                                        <GoDotFill size={26} color='red'></GoDotFill>
                                    </div>
                                </div>
                                <div>
                                    <div className='text-gray f-14 bold ps-1'>9:00 - 10:00 AM</div>
                                    <div className='text-gray f-12 line-0 ps-1'>Cita con Jannet Castro</div>
                                    <div className='text-blue f-12 ps-1'>Sucursal San Nicolas</div>
                                </div>
                            </div>

                            <div className='d-flex ps-2 pe-4 py-2'>
                                <div>
                                    <div className='bv-icon bv-icon--mid'>
                                        <GoDotFill size={26} color='gray'></GoDotFill>
                                    </div>
                                </div>
                                <div>
                                    <div className='text-gray f-14 bold ps-1'>9:00 - 10:00 AM</div>
                                    <div className='text-gray f-12 line-0 ps-1'>Cita con Jannet Castro</div>

                                    <div className='d-flex align-items-center'>
                                        <div className='bv-icon bv-icon--mid'>
                                            <HiOutlineVideoCamera size={20} color="#0972CE"></HiOutlineVideoCamera>
                                        </div>
                                        <div className='text-blue f-12'>Videollamada</div>
                                    </div>
                                    

                                </div>
                            </div>

                            <div className='d-flex ps-2 pe-4 py-2'>
                                <div>
                                    <div className='bv-icon bv-icon--mid'>
                                        <GoDotFill size={26} color='#0972CE'></GoDotFill>
                                    </div>
                                </div>
                                <div>
                                    <div className='text-gray f-14 bold ps-1'>9:00 - 10:00 AM</div>
                                    <div className='text-gray f-12 line-0 ps-1'>Cita con Jannet Castro</div>

                                    <div className='d-flex align-items-center'>
                                        <div className='bv-icon bv-icon--mid'>
                                            <HiOutlineVideoCamera size={20} color="#0972CE"></HiOutlineVideoCamera>
                                        </div>
                                        <div className='text-blue f-12'>Videollamada</div>
                                    </div>
                                

                                </div>
                            </div>

                            <div className='text-gray text-center f-16 line-0 ps-1 mt-3'><span className='bolder'>Lunes:</span> 26/11/2024 </div> */}



                            </div>

                            <div className='col px-3'>

                                <div className='d-flex py-3'>

                                    <div className='col'>
                                        {/* <div className='input--light'>
                                            <div className='bv-icon bv-icon--mid'><AiOutlineSearch size={30}></AiOutlineSearch></div>
                                            <input className='bg-transparent' placeholder='Busca Especialista'onChange={(evt) => {
                                                console.log(evt.currentTarget.value)
                                                console.log(state.citas);
                                                // let date = new Date(Date.parse(evt.currentTarget.value))
                                                // date.setHours('00', '00', '00')
                                                // addDays(1, date)

                                                // console.log(date)
                                                // setState({ ...state, init_date: date })
                                            }}></input>
                                        </div> */}
                                        <DropDown
                                            title='Seleccione el Profesional'
                                            open={false}
                                            // defaultValue={0} 
                                            _onChange={(evt) => {
                                                console.log(evt)
                                                setState({ ...state, selected_specialist_search: evt.value })
                                            }}>

                                            {
                                                state.specialists_couch_s.map((item, i) => {
                                                    // console.log(item)
                                                    return (
                                                        <DropDownOption key={i} value={item} label={`${item.firstName} ${item.lastName}`}>
                                                            <div className='f-14 text-gray'>{item.firstName} {item.lastName}</div>
                                                        </DropDownOption>
                                                    )
                                                })
                                            }




                                        </DropDown>
                                    </div>



                                    <div className='col d-flex align-items-center justify-content-end'>
                                        <div className='f-14 text-gray'><span className='bold'>Semana:</span></div>
                                    </div>


                                    <div className='mx-3'>
                                        <div className='input--light'>
                                            <div className='bv-icon bv-icon--mid'><BiCalendar size={30}></BiCalendar></div>
                                            <input type='date' className='bg-transparent' placeholder='Busca Especialista' onChange={(evt) => {
                                                console.log(evt.currentTarget.value)
                                                let date = new Date(Date.parse(evt.currentTarget.value))
                                                date.setHours('00', '00', '00')
                                                addDays(1, date)

                                                console.log(date)
                                                setState({ ...state, init_date: date })
                                            }}></input>
                                        </div>
                                    </div>


                                    <div className='bv-cta bv-cta--primary' onClick={() => {
                                        setState({ ...state, show_agendar_cita: true })
                                    }}>
                                        Agendar

                                    </div>
                                    <div style={{ width: 100 }}></div>
                                </div>

                                <div className='d-flex'>

                                    {
                                        ['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sabado'].map((item, i) => {

                                            return (
                                                <div className='col'>

                                                    <div className={`daytile ${state.init_date.getDay() === i ? 'bg-light' : ''}`}>
                                                        <div className='text-gray f-14'>{item}</div>
                                                        <div className='text-dark f-16 bold'>{getRestDays(state.init_date.getDay(), state.init_date.getDate(), i)}</div>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                    {/* <div className='col'>
                                    <div className='daytile'>
                                        <div className='text-gray f-14'>Lunes</div>
                                        <div className='text-dark f-16 bold'>21</div>
                                    </div>
                                </div>
                                <div className='col'>
                                    <div className='daytile'>
                                        <div className='text-gray f-14'>Martes</div>
                                        <div className='text-dark f-16 bold'>21</div>
                                    </div>
                                </div>
                                <div className='col'>
                                    <div className='daytile'>
                                        <div className='text-gray f-14'>Miercoles</div>
                                        <div className='text-dark f-16 bold'>21</div>
                                    </div>
                                </div>
                                <div className='col'>
                                    <div className='daytile'>
                                        <div className='text-gray f-14'>Jueves</div>
                                        <div className='text-dark f-16 bold'>21</div>
                                    </div>
                                </div>
                                <div className='col'>
                                    <div className='daytile'>
                                        <div className='text-gray f-14'>Viernes</div>
                                        <div className='text-dark f-16 bold'>21</div>
                                    </div>
                                </div>
                                <div className='col'>
                                    <div className='daytile bg-light'>
                                        <div className='text-gray f-14'>Sabado</div>
                                        <div className='text-dark f-16 bold'>21</div>
                                    </div>
                                </div>
                                <div className='col'>
                                    <div className='daytile'>
                                        <div className='text-gray f-14'>Domingo</div>
                                        <div className='text-dark f-16 bold'>21</div>
                                    </div>
                                </div> */}


                                    <div className='p-3' style={{ width: 100 }}>
                                        <div className='text-gray f-12 bold line-0'>EST <br></br> GMT-5</div>
                                    </div>

                                </div>


                                {
                                    time.map((item, i) => {
                                        // console.log(item);
                                        return (
                                            <div key={i} className='d-flex'>
                                                {[0, 1, 2, 3, 4, 5, 6].map((tile, j) => {
                                                    let tile_date = getTileDate(state.init_date.getDay(), state.init_date.getDate(), j)
                                                    tile_date.setHours(times[i], '00', '00');
                                                    let cita = TileAppointmentCheck(tile_date);
                                                    return (
                                                        <div key={j} className='col'>
                                                            <div className='daytile'>
                                                                {/* <div className='f-10'>{tile_date.toString()}</div> */}

                                                                <Renderif isTrue={cita?.reserved}>
                                                                    <div className='d-flex'>
                                                                        <div>
                                                                            <div className='bv-icon'>

                                                                                <GoDotFill size={26} color='#0972CE'></GoDotFill>
                                                                            </div>

                                                                        </div>
                                                                        <div onClick={() => {
                                                                            setState({ ...state, show_editar_cita: true, cita_editing: cita.cita })
                                                                        }}>
                                                                            <div className='f-12 bold ps-1'>{new Date(time_mock[i]).getHours() - 1}:{new Date(time_mock[i]).getMinutes()} - {new Date(time_mock[i]).getHours()}:{new Date(time_mock[i]).getMinutes()}</div>
                                                                            <div className='text-gray f-10 line-0 ps-1'>Cita con {cita?.cita?.patient?.firstName} {cita?.cita?.patient?.lastName}</div>

                                                                            <div className='d-flex align-items-center'>
                                                                                <div className='bv-icon'>
                                                                                    <HiOutlineVideoCamera size={30} color="#0972CE"></HiOutlineVideoCamera>
                                                                                </div>
                                                                                <div className='text-blue f-10 ps-1'>Videollamada</div>
                                                                            </div>


                                                                        </div>
                                                                    </div>
                                                                </Renderif>
                                                            </div>
                                                        </div>
                                                    )
                                                })}

                                                <div className='p-3' style={{ width: 100 }}>
                                                    <div className='text-gray f-12 bold line-0'>{item}</div>
                                                </div>


                                            </div>
                                        )
                                    })
                                }


                            </div>
                        </div>




                    </div>
                    <div className='my-5'></div>
                </div>
            </div>
        </>

    )
}



export function Rating({ value = 5 }) {

    return (
        <div className='d-flex'>
            <div className='bv-icon '>

                <Renderif isTrue={value > 0}>
                    <GoStarFill color='#FFA800'></GoStarFill>
                </Renderif>
                <Renderif isTrue={value < 1}>
                    <GoStar color='#CCC'></GoStar>
                </Renderif>

            </div>

            <div className='bv-icon'>
                <Renderif isTrue={value > 1}>
                    <GoStarFill color='#FFA800'></GoStarFill>
                </Renderif>
                <Renderif isTrue={value < 2}>
                    <GoStar color='#CCC'></GoStar>
                </Renderif>
            </div>

            <div className='bv-icon'>
                <Renderif isTrue={value > 2}>
                    <GoStarFill color='#FFA800'></GoStarFill>
                </Renderif>
                <Renderif isTrue={value < 3}>
                    <GoStar color='#CCC'></GoStar>
                </Renderif>
            </div>

            <div className='bv-icon'>
                <Renderif isTrue={value > 3}>
                    <GoStarFill color='#FFA800'></GoStarFill>
                </Renderif>
                <Renderif isTrue={value < 4}>
                    <GoStar color='#CCC'></GoStar>
                </Renderif>
            </div>

            <div className='bv-icon'>
                <Renderif isTrue={value > 4}>
                    <GoStarFill color='#FFA800'></GoStarFill>
                </Renderif>
                <Renderif isTrue={value < 5}>
                    <GoStar color='#CCC'></GoStar>
                </Renderif>
            </div>
        </div>
    )
}


